import { render, staticRenderFns } from "./mktAttachments.vue?vue&type=template&id=5dec7027&"
import script from "./mktAttachments.vue?vue&type=script&lang=js&"
export * from "./mktAttachments.vue?vue&type=script&lang=js&"
import style0 from "./mktAttachments.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports